import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { Tag, Input, Divider } from 'antd';

import Modal from '../../../../components/uiComponent/modal/index';
import WarningIcon from '../../../../assets/icons/warning-modal-icon.svg';
import { ModalWrapper } from '../../../purchase-order/po-warehouse-details/custom-drawer/style';

const MAX_NAME_LENGTH = 255;

const getPackingMethodBadge = (wo) => {
  const method = (wo?.packing_method || '').toLowerCase();
  const shipmentType = (wo?.shipment_type || '').toUpperCase();
  if (method === 'pack_now') {
    const isSP = shipmentType === 'SP' || shipmentType === 'GROUND_SMALL_PARCEL' || shipmentType === 'SPD';
    return (
      <Tag color={isSP ? 'green' : 'blue'} style={{ marginLeft: 8 }}>
        Pack-Now {isSP ? 'SPD' : (shipmentType || 'LTL')} — boxes will be moved
      </Tag>
    );
  }
  if (method === 'pack_later') {
    return (
      <Tag color="orange" style={{ marginLeft: 8 }}>
        Pack-Later — boxes will be discarded
      </Tag>
    );
  }
  return null;
};

const MergeWorkOrdersModal = ({ open, onClose, onConfirm, selectedWorkOrders = [], loading }) => {
  const [orderName, setOrderName] = useState('');

  useEffect(() => {
    if (open) setOrderName('');
  }, [open]);

  const trimmedName = orderName.trim();
  const nameInvalid = !trimmedName || trimmedName.length > MAX_NAME_LENGTH;

  return (
    <Modal
      open={open}
      onClose={onClose}
      onHide={onClose}
      onSave={() => onConfirm(trimmedName)}
      closeText="Cancel"
      saveText={loading ? 'Merging...' : 'Confirm Merge'}
      header="Merge Work Orders"
      className="delete-confirmation-modal merge-wo-modal"
      closeButton={true}
      buttonDisabled={loading || selectedWorkOrders.length < 2 || nameInvalid}
    >
      <ModalWrapper>
        <div className="delete-modal-wrapper">
          <img src={WarningIcon} alt="WarningIcon" title="WarningIcon" />
          <Typography
            component="h3"
            sx={{
              fontSize: { xs: 18, sm: 20 },
              fontWeight: 700,
              mt: 2,
              textAlign: 'center',
            }}
          >
            Merge {selectedWorkOrders.length} Work Orders?
          </Typography>
          <p style={{ marginTop: 12, marginBottom: 8, fontSize: 13, lineHeight: 1.5 }}>
            A new Draft work order will be created with merged items. Items sharing the same SKU collapse into one row (oldest expiry wins, quantities sum). Source work orders will be archived.
          </p>

          <div style={{ width: '100%', alignSelf: 'stretch', textAlign: 'left', marginTop: 16 }}>
            <Typography
              component="div"
              sx={{
                fontSize: 13,
                fontWeight: 600,
                color: '#1B2559',
                mb: 1,
                textAlign: 'left',
              }}
            >
              New Work Order Name
            </Typography>
            <Input
              value={orderName}
              onChange={(e) => setOrderName(e.target.value)}
              placeholder="Enter a name for the merged work order"
              maxLength={MAX_NAME_LENGTH}
              size="large"
              disabled={loading}
              status={trimmedName === '' && orderName !== '' ? 'error' : ''}
            />
          </div>

          <Divider style={{ margin: '20px 0 12px', borderColor: '#E5E7EB' }} />

          <div style={{ width: '100%', alignSelf: 'stretch', textAlign: 'left' }}>
            <Typography
              component="div"
              sx={{
                fontSize: 13,
                fontWeight: 600,
                color: '#1B2559',
                mb: 1,
                textAlign: 'left',
              }}
            >
              The following work orders will be merged
            </Typography>
            <div style={{ maxHeight: 'min(280px, 40vh)', overflowY: 'auto', border: '1px solid #E5E7EB', borderRadius: 6 }}>
              {selectedWorkOrders.map((wo, idx) => (
                <div
                  key={wo.id}
                  style={{
                    padding: '10px 12px',
                    borderBottom: idx === selectedWorkOrders.length - 1 ? 'none' : '1px solid #E5E7EB',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    fontSize: 13,
                    color: '#1F2937',
                  }}
                >
                  <span style={{ marginRight: 10, color: '#7E8A90', minWidth: 20, fontWeight: 500, flexShrink: 0 }}>
                    {idx + 1}.
                  </span>
                  <span
                    style={{
                      fontWeight: 600,
                      marginRight: 8,
                      wordBreak: 'break-word',
                      overflowWrap: 'anywhere',
                      minWidth: 0,
                      flex: '1 1 auto',
                    }}
                  >
                    {wo.order_name || `#${wo.id}`}
                  </span>
                  {getPackingMethodBadge(wo)}
                </div>
              ))}
            </div>
          </div>
        </div>
      </ModalWrapper>
    </Modal>
  );
};

export default MergeWorkOrdersModal;
